import { render, staticRenderFns } from "./EnforceApply.vue?vue&type=template&id=bb99b308&scoped=true"
import script from "./EnforceApply.vue?vue&type=script&lang=js"
export * from "./EnforceApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb99b308",
  null
  
)

export default component.exports